import { createReducer } from '@reduxjs/toolkit';
import { SET_CONFIG } from '../constants/actionTypes';
import { Config } from '../types';

export const configInitialState: Config = {
  cloudName: '',
  themesPath: '',
  themes: [],
};

export const config = createReducer(
  configInitialState,
  {
    [SET_CONFIG]: (
      state: Config,
      resp: {
        payload: Config;
      }
    ) => resp.payload,
  },
);
